/* Shared look for the specimen screens: theme tokens only (src/theme). */

export const card = {
  background: 'var(--c-surface)', border: '1px solid var(--c-border)', borderRadius: 10,
  padding: 16, marginTop: 16,
};

export const sectionTitle = { margin: '0 0 10px', fontSize: 16 };

export const label = { display: 'flex', flexDirection: 'column', gap: 4, fontSize: 14, fontWeight: 500 };

export const hint = { fontSize: 12, color: 'var(--c-text-muted-fg)', fontWeight: 400, lineHeight: 1.45 };

export const input = {
  padding: '7px 10px', border: '1px solid var(--c-border-strong)', borderRadius: 6, fontSize: 14,
  fontWeight: 400, background: 'var(--c-surface)', color: 'var(--c-text-fg)', minWidth: 0,
};

export const row = { display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'flex-end' };

/* No minHeight on the buttons: an inline one beats index.css's 44 px for a
 * touch screen (a rule in a stylesheet loses to the style attribute), and
 * with the mouse the padding already gives them a comfortable height. */
export const btn = (bg = 'var(--c-primary)') => ({
  background: bg, color: 'var(--c-on-accent)', border: 'none', borderRadius: 6,
  padding: '8px 14px', cursor: 'pointer', fontSize: 14,
});

export const ghostBtn = {
  background: 'var(--c-surface)', color: 'var(--c-text-fg)', border: '1px solid var(--c-border-strong)',
  borderRadius: 6, padding: '7px 12px', cursor: 'pointer', fontSize: 14,
};

export const mono = { fontFamily: 'ui-monospace, SFMono-Regular, Consolas, monospace' };

export const error = { color: 'var(--c-danger-fg)', fontSize: 13, margin: '8px 0 0' };

export const warning = {
  fontSize: 13, color: 'var(--c-warning-text-fg)', background: 'var(--c-warning-soft)',
  border: '1px solid var(--c-warning)', borderRadius: 8, padding: '10px 12px', lineHeight: 1.45,
};

export const STATUS_COLORS = {
  reserved: { bg: 'var(--c-info-soft)', fg: 'var(--c-info-fg)' },
  active: { bg: 'var(--c-success-soft)', fg: 'var(--c-success-fg)' },
  archived: { bg: 'var(--c-bg-muted)', fg: 'var(--c-text-muted-fg)' },
  void: { bg: 'var(--c-danger-soft)', fg: 'var(--c-danger-fg)' },
};

export const pill = (status) => ({
  display: 'inline-block', padding: '2px 10px', borderRadius: 999, fontSize: 12, fontWeight: 600,
  background: (STATUS_COLORS[status] || STATUS_COLORS.archived).bg,
  color: (STATUS_COLORS[status] || STATUS_COLORS.archived).fg,
});

export const dl = { display: 'grid', gridTemplateColumns: 'minmax(120px, max-content) 1fr', gap: '6px 16px', margin: 0 };
export const dt = { fontSize: 13, fontWeight: 600, color: 'var(--c-text-muted-fg)' };
export const dd = { margin: 0, fontSize: 14, overflowWrap: 'anywhere' };
